import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import { type ResponseHeader, ResponseHeaderSchema } from '../responseHeader'
import {
  ListHumanProxiesResponsePayload,
  ListHumanProxiesResponsePayloadSchema,
} from './listHumanProxiesResponsePayload'

export type ListHumanProxiesResponse = {
  header: ResponseHeader
  payload?: ListHumanProxiesResponsePayload
}

export const ListHumanProxiesResponseSchema: CborSchema<ListHumanProxiesResponse> =
  defineCborSchema<ListHumanProxiesResponse>({
    header: CborField({ key: 0, type: ResponseHeaderSchema }),
    payload: CborField({
      key: 1,
      required: false,
      type: ListHumanProxiesResponsePayloadSchema,
    }),
  })
